import { mergeClasses, ProgressBar } from '@fluentui/react-components';
import { Calendar16Regular } from '@fluentui/react-icons';

import { useHealthGoalBodyForStepsExerciseStyles } from './HealthGoalBodyForStepsExercise.styles';

export interface HealthGoalBodyData {
  calendarRange: string
  calculatedUnit: string
  currentMeasurementCount: string
  measurementUnit: string
  progressValue: number | null
  goalRepeatabilityRate: string | null
}

interface HealthGoalBodyForStepsExerciseProps {
  healthGoalBody: HealthGoalBodyData
  className?: string
}

const HealthGoalBodyForStepsExercise: React.FC<HealthGoalBodyForStepsExerciseProps> = ({
  healthGoalBody: healthGoalBodyForStepsExercise,
  className,
}) => {
  const styles = useHealthGoalBodyForStepsExerciseStyles();
  const { calendarRange, calculatedUnit, currentMeasurementCount, measurementUnit, progressValue, goalRepeatabilityRate }
    = healthGoalBodyForStepsExercise;
  const renderProgressBar = (): React.ReactNode => {
    return progressValue != null && (
      <div className={styles.progressBar} data-testid="health-goal-progress-bar">
        <ProgressBar value={progressValue} max={100} shape="rounded" thickness="large" />
      </div>
    );
  };

  const renderGoalRepeatabilityRate = (): React.ReactNode => {
    return goalRepeatabilityRate && (
      <div className={styles.goalRepeatabilityRate} data-testid="health-goal-repeatability-rate">
        {goalRepeatabilityRate}
      </div>
    );
  };

  return (
    <div
      className={mergeClasses('health-goal-body-for-steps-exercise-container', styles.body, className)}
      data-testid="health-goal-body-for-steps-exercise"
    >
      <div className={styles.leftRightWrapper}>
        <div className={styles.leftSection}>
          <div className={styles.calendar}>
            <Calendar16Regular />
            {calendarRange}
          </div>
        </div>

        <div className={styles.rightSection}>
          {renderGoalRepeatabilityRate()}
        </div>
      </div>

      <span className={styles.calculatedUnit}>{calculatedUnit}</span>

      <div data-testid="health-goal-measurement-count">
        <span className={styles.measurementCount}>{currentMeasurementCount}</span>
        {measurementUnit}
      </div>

      {renderProgressBar()}
    </div>
  );
};

export default HealthGoalBodyForStepsExercise;
